<div class="snack-bar-container">
    <span class="content">{{data}}</span>
    <span class="material-icons" (click)="close()">close</span>
</div>
